import { withRBAC } from "../rbac";
import { CompanyCreate } from "./CompanyCreate";
import { CompanyEdit } from "./CompanyEdit";
import { CompanyList } from "./CompanyList";
import { CompanyPage } from "./CompanyPage";
import { CompanyShow } from "./CompanyShow";

export default {
  list: withRBAC(CompanyList, "view_sales_pipeline"),
  create: withRBAC(CompanyCreate, "view_sales_pipeline"),
  edit: withRBAC(CompanyEdit, "view_sales_pipeline"),
  show: withRBAC(CompanyShow, "view_sales_pipeline"),
};

export { CompanyPage };
